export default {"src":"/_next/static/media/down-lt.bac39a25.svg","height":9,"width":13,"blurWidth":0,"blurHeight":0};